module.exports = __webpack_public_path__ + "img/gift_opened.e19290f0.png";